// extracted by mini-css-extract-plugin
module.exports = {"swiper-top-banner":"carousel_swiper-top-banner__hOiYo","swiper-bottom-banner":"carousel_swiper-bottom-banner__5Zt4F"};